import { useAtom } from 'jotai';
import {
  loadingStateAtom,
  showLoadingAtom,
  updateProgressAtom,
  hideLoadingAtom,
} from '../atoms/loadingAtom';

export const useLoading = () => {
  const [loadingState] = useAtom(loadingStateAtom);
  const [, showLoading] = useAtom(showLoadingAtom);
  const [, updateProgress] = useAtom(updateProgressAtom);
  const [, hideLoading] = useAtom(hideLoadingAtom);

  return {
    loadingState,
    showLoading,
    updateProgress,
    hideLoading,
  };
};
